import { FC } from "react";
import { Link } from "react-router-dom";
import { TAB_BRAND_ICON } from "../../config/constants";
import { LEGAL_DOC_HREFS } from "../../legal/legalDocRoutes";
import "./SiteFooter.scss";

export const SiteFooter: FC = () => (
  <footer className="site-footer">
    <div className="site-footer__wrap">
      <div className="site-footer__grid">
        <div>
          <Link className="site-footer__brand" to="/home">
            <img
              className="site-footer__brand-logo"
              src={TAB_BRAND_ICON}
              alt=""
              aria-hidden="true"
            />
            <span>Lychee Voice</span>
          </Link>
          <p>为全球开发者与企业提供稳定、可靠、可扩展的语音能力。</p>
          <div className="site-footer__socials">
            <a className="site-footer__social-link" href="#" aria-label="抖音">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M14 3v10.2a4.7 4.7 0 1 1-3-4.4" />
                <path d="M14 3c1.1 3 3.1 4.7 6 5" />
              </svg>
              <img className="site-footer__social-qr" src="/img/ma2.png" alt="抖音二维码" />
            </a>
            <a className="site-footer__social-link" href="#" aria-label="小红书">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="4" y="5" width="16" height="14" rx="3" />
                <path d="M8 10h8M8 14h5" />
              </svg>
              <img className="site-footer__social-qr" src="/img/ma1.png" alt="小红书二维码" />
            </a>
          </div>
        </div>

        <div>
          <h4>产品</h4>
          <Link to="/hub/ai-voice">AI 音频</Link>
          <Link to="/hub/podcast">AI 播客</Link>
          <Link to="/hub/ai-image">AI 生图</Link>
        </div>

        <div>
          <h4>开发者</h4>
          <Link to="/api_doc">API 文档</Link>
        </div>

        <div className="site-footer__contact">
          <h4>联系我们</h4>
          <p>
            深圳市中粮前海创新中心东塔 27 楼
            <br />
            长沙市金茂大厦 1206
          </p>
          <a href="tel:17397388378">17397388378</a>
        </div>
      </div>

      <div className="site-footer__copyright">
        <span>© 2026 Lychee Voice. All rights reserved.</span>
        <span className="site-footer__legal-links">
          <a
            href={LEGAL_DOC_HREFS.userAgreement}
            target="_blank"
            rel="noopener noreferrer"
          >
            用户协议
          </a>
          <a
            href={LEGAL_DOC_HREFS.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            隐私政策
          </a>
        </span>
      </div>
    </div>
  </footer>
);

export default SiteFooter;